import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import {MapsCommonService} from "../../../map/services/mapsCommon.service";

export class selfPickupMapCtrl implements IController {

  depot: any;

  private map: any;
  private depotMarkers: any;
  private depotMarkersControl: any;
  private isReadyRef: boolean;
  private mapInstance: any;

  /* @ngInject */
  constructor(private mapsCommonService: MapsCommonService, private $timeout: ITimeoutService, private uiGmapIsReady) {
  }

  $onInit() {
    this.isReadyRef = false;

    this.map = {
      isReady: this.isReadyRef,
      center: this.mapsCommonService.getSiteLocation(),
      zoom: 14,
      options: {
        styles: this.mapsCommonService.getDefaultStyle(),
        mapTypeControl: false
      },
      events: {
        idle: (map) => {
          if (!this.isReadyRef) {
            this.isReadyRef = true;
            google.maps.event.trigger(map, 'resize');
            // resizeService.resize();
          }
        }
      },
      bounds: {},
      control: {}
    };

    this.depotMarkers = [];
    this.depotMarkersControl = [];

    if (this.depot) {
      this.depotMarkers = this.mapsCommonService.getDepotMarkers([this.depot]);
      this._setZoom()
    }
  };

  $onChanges(changes) {
    if (changes.depot && !changes.depot.isFirstChange()) {
      this.$onInit();
    }
  };


  _setZoom() {
    if (this.mapInstance) {
      this.$timeout(0).then(() => {
        this.mapInstance.mapInstance.setZoom(18);
      });
    } else {
      this.uiGmapIsReady.promise(1).then((maps) => {
        this.$timeout(0).then(() => {
          maps[0].map.setZoom(15);
        });
        // ctrl.mapInstance = ctrl.map.control.getGMap();
        // ctrl.mapInstance.mapInstance.setZoom(18);
      });
    }
  }
}

angular
  .module('bringoz.admin.self-pickups')
  .component('selfPickupMap', {
    bindings: {
      depot: '<'
    },
    template: require('./self-pickup-map.html').default,
    controller: selfPickupMapCtrl
  });
